import './App.css';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import moon from './assets/moon.svg';
import sun from './assets/sun.svg';
import nightBuildings from './assets/night-buildings.svg';
import buildings from './assets/buildings.svg';
import nightSol from './assets/night-sol.svg';
import ferry from './assets/ferry.svg';
import MapPage from './MapPage';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import HomePageMobile from './components/HomePageMobile';
import MobileRedirect from './components/MobileRedirect';
import AboutPage from './components/AboutPage';
import ResumePage from './components/ResumePage';
import StatueOfLiberty from './animations/statue-of-liberty';
import Buildings from './animations/buildings';
import Ferry from './animations/ferry';
import MobileWarning from './components/MobileWarning';
import LoginPopup from './components/LoginPopup';
import { motion } from "motion/react"
import { checkDayTime } from './utils/dayNightUtils';

function HomePage() {
  const navigate = useNavigate();
  const [isDay, setIsDay] = useState(true); 
  const [loading, setLoading] = useState(true);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    checkDayTime(setIsDay, setLoading);
    // Update every 30 minutes
    const interval = setInterval(() => checkDayTime(setIsDay), 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <MobileWarning />
      <div className={classNames("personal-website cursor-pointer", {
        "day-time": isDay,
        "night-time": !isDay
      })}>
       <img src={sun} alt="sun" className={classNames("sun-moon", {
        "visible": isDay,
        "hidden": !isDay
      }) } />
        <img src={moon} alt="moon" className={classNames("sun-moon", {
        "visible": !isDay,
        "hidden": isDay
      }) }/>
        <div 
    className="time-toggle-container"
    onMouseEnter={() => setIsHovering(true)}
    onMouseLeave={() => setIsHovering(false)}
    onClick={() => setIsDay(!isDay)}
  >
    { !loading ? (
      <svg 
        className={classNames("sun-moon-toggle", {
          "day": isDay,
          "night": !isDay 
        })}
        viewBox="0 0 32 32"
      >
        <defs>
          <mask id="maskc">
            <rect x="0" y="0" width="32" height="32" fill="white"/>
            <circle id="mask-center" cx="40" cy="16" r="8" fill="black"/>
          </mask>
          <mask id="maskr">
            <circle id="mask-rays" cx="16" cy="16" r="16" fill="white"/>
          </mask>
        </defs>
        <circle id="center" mask="url(#maskc)" r="8" cx="16" cy="16"/>
        <path id="rays" mask="url(#maskr)" d="M6,16l-6,0 M8.929,8.929l-4.243,-4.243 M8.929,23.071l-4.243,4.243 M16,26l-0,6 M27.314,27.314l-4.243,-4.243 M32,16l-6,0 M27.314,4.686l-4.243,4.243 M16,-0l-0,6"/>
      </svg>
    ) : <div>Loading..</div>}
  </div>
     <div className="relative">
     <div className="personal-website-header">
        <div className="header-text">
        <h1  className={classNames(   {
        "text-color-day": isDay,
        "text-color-night": !isDay
      })}>Evan Habersham</h1>

<p  className={classNames(   {
        "text-color-day": isDay,
        "text-color-night": !isDay
      })}>Software Engineer based in NYC</p>
<div style={{ display: 'flex', gap: '12px', alignItems: 'center', justifyContent: 'center' }}>


  <button 
    className={classNames("time-toggle-button", {
      "day": isDay,
      "night": !isDay 
    })}
    onClick={() => navigate('/map')}
  >
      <div className="button-text-container">
      <div className={classNames("button-text", {
        "visible": isDay,
        "hidden": !isDay
      })}>
           View Map
      </div>
      <div className={classNames("button-text", {
        "visible": !isDay,
        "hidden": isDay
      })}>
        View Map
      </div>
    </div>

  </button>
  
</div>

        </div>
 
  
      </div>
     </div>
 
     <Buildings isDay={isDay} />

     {/* <motion.path
  d={d}
  initial={{ pathLength: 0 }}
  animate={{ pathLength: 1 }}
/>
     <motion.div
     style={{ position: 'absolute', zIndex: 1000,     width: 100,
      height: 100,
      backgroundColor: "#ff0088",
      borderRadius: 5,
    top: 100,
  left: 100 }}
  animate={{
    scale: 2,
    transition: { duration: 2 }
  }}
/> */}

<div className="ocean-container">
<div className={classNames("ocean", {
        "day-ocean": isDay,
        "night-ocean": !isDay
      })}>
        <svg viewBox="0 0 100 25">
          <path className="squiggly-line" d="M0,5 C20,0 30,10 50,5 C70,0 80,10 100,5" />
        </svg>
      </div>
</div>

      <StatueOfLiberty isDay={isDay} /> 
   <Ferry isDay={isDay} />
      {/* <img src={ferry} alt="ferry" classNames="ferry"  /> */}
      </div>
   
    </div>  
  );
}

function App() {
  return (
    <BrowserRouter>
      <MobileRedirect>
        <LoginPopup />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mobile-home" element={<HomePageMobile />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/resume" element={<ResumePage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </MobileRedirect>
    </BrowserRouter>
  );
}

export default App;
